import { User, VoyagerPlanner } from '@/types/api';
import { create } from 'zustand';

interface plannerStore {
  voyagerPlanners: Array<VoyagerPlanner>;
  setPlanners: (voyagerPlanners: Array<VoyagerPlanner>) => void;
  selectedPlanner: VoyagerPlanner | null;
  setSelectedPlanner: (planner: VoyagerPlanner | null) => void;
  showModalFormPlanner: boolean;
  setShowModalFormPlanner: (show: boolean) => void;
  plannermarker: any;
  setPlannerMarker: (key: string, value: any) => void;
  deletePlanner: (key: string) => void; // Step 1: Add deletePlanner function
  showModalDetailPlanner: boolean;
  setShowModalDetailPlanner: (show: boolean) => void;
}

const usePlannerStore = create<plannerStore>((set) => ({
  voyagerPlanners: [],
  setPlanners: (voyagerPlanners) => set({ voyagerPlanners: voyagerPlanners }),
  selectedPlanner: null,
  setSelectedPlanner: (planner) => set({ selectedPlanner: planner }),
  showModalFormPlanner: false,
  setShowModalFormPlanner: (show: boolean) => set({ showModalFormPlanner: show }),
  plannermarker: {},
  setPlannerMarker: (key, val) => {
    set((state) => ({
      plannermarker: {
        ...state.plannermarker,
        [key]: val,
        [String(key)]: val,
      },
    }));
  },
  deletePlanner: (key) => {
    set((state) => {
      const { plannermarker } = state;
      const newPlannerMarker = { ...plannermarker };
      delete newPlannerMarker[key];
      delete newPlannerMarker[String(key)];
      return { plannermarker: newPlannerMarker };
    });
  },
  showModalDetailPlanner: false,
  setShowModalDetailPlanner: (show: boolean) => set({ showModalDetailPlanner: show }),
}));

export default usePlannerStore;
